import React from "react";
import "./HomeHeroSection.css";

const HomeHeroSection = () => {

    const handleButtonClick = () => {
      window.open("https://forms.gle/tdeZFWJxi1jRYXHF6");
    };
  return (
    <section className="home-hero-section">
      <div className="home-hero-content">
        <h1 className="home-hero-heading">
          <span>Empowering Careers,</span> <br /> Building Digital Dreams.
        </h1>
        <p className="home-hero-subtext">
          <em>
            We help students and professionals turn ambition into action —
            offering real-time guidance, digital solutions, and growth that
            lasts.
          </em>
        </p>
        <button className="home-hero-btn" onClick={handleButtonClick}>
          Know More
        </button>
      </div>
    </section>
  );
};

export default HomeHeroSection;
